import React from 'react';
import Button from '@mui/material/Button';
import BotaoVoltar from "./common/botaoVoltar";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Paper from '@mui/material/Paper';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import $ from 'jquery'
import 'datatables.net-dt/js/dataTables.dataTables'
import 'datatables.net-dt/css/jquery.dataTables.min.css'
import {URL_API} from '../config/urls'
import fetchWithToken from 'config/UseFetchWithToken';

const mensagem = `<!DOCTYPE html>
<html lang="pt">
	<head>
		<title>DISTVAF -Secretaria de Estado de Fazenda de Minas Gerais</title>
		<meta charset="utf-8"/>
		<link rel="preconnect" href="https://fonts.googleapis.com">
		<link rel="preconnect" href="https://fonts.gstatic.com">
		<link href="https://fonts.googleapis.com/css?family=Open+Sans:300,400,500,600,400italic,600italic|Roboto+Slab:400,700" rel="stylesheet">
	</head>       
	<body style="margin:0;padding:0;font-family:'Open Sans',Arial,sans-serif\font-size:14px;">
	<div align="center">
	<table style="background: #d9d9d9; margin: 50 0px;" border="0" width="800" cellspacing="0" cellpadding="0">
		<tbody>
		<tr>
			<td><img src="cid:image" /></td>
		</tr>
		<tr>
			<td style="padding: 16px;">
			<table style="background: #ffffff;" border="0" width="100%" cellspacing="0" cellpadding="0">
				<tbody>
				<tr>
					<td style="padding: 100 0px;">
					<p style="text-align: center; font-size: 36pt; font-family: Roboto,RobotoDraft,Helvetica,Arial,sans-serif;"><strong>[TITULO]</strong></p>
					</td>
				</tr>
				<tr>
					<td style="padding: 40px;">
					<p style="text-align: justify; font-size: 14pt; color: black; font-family: Roboto,RobotoDraft,Helvetica,Arial,sans-serif;">[TEXTO]</p>
					</td>
				</tr>
				<tr>
					<td style="padding: 20 0 100 0px;">
					<p style="text-align: center; font-size: 14pt; color: black; font-family: Roboto,RobotoDraft,Helvetica,Arial,sans-serif;">[ASSINATURA]</p>
					</td>
				</tr>
				</tbody>
			</table>
			</td>
		</tr>
		<tr>
			<td style="background: transparent; padding: 0cm 0cm 0cm 0cm;">
			<p style="text-align: center; font-size: 12pt; color: black; font-family: Roboto,RobotoDraft,Helvetica,Arial,sans-serif;">Belo Horizonte, [DATA]</p>
			</td>
		</tr>
		<tr>
			<td style="padding: 50 150px;">
			<p style="text-align: center; font-size: 10pt; color: black; font-family: Roboto,RobotoDraft,Helvetica,Arial,sans-serif;">Esta &eacute; uma mensagem gerada pelo sistema. N&atilde;o a responda.<br />Voc&ecirc; est&aacute; recebendo este e-mail como resultado<br />do seu relacionamento atual com a<br />Secretaria de Estado de Fazenda de Minas Gerais</p>
			</td>
		</tr>
		</tbody>
			</table>
		</div>
	</body>
</html>`

class EnviarInformativo extends React.Component {

	constructor(props) {
		super(props)
		this.state = {
			ano: "",
			arquivoAnexado: false,
			assinatura: "",
			assunto: "",
			corpo: "",
			dadosAf: [],
			dadosPrefeitura: [],
			dadosSrf: [],
			idsAf: [],
			idsPrefeitura: [],
			idsSrf: [],
			marcadosAf: [],
			marcadosPrefeitura: [],
			marcadosSrf: [],
			mensagem: "",
			mostraMensagem: false,
			mostraModal: false,
			nomeArquivo: "*",
			numeroRetorno: "",
			qualTab: "2",
			texto: "",
			tipoArquivo: "",
			titulo: "",
			tudoAf: false,
			tudoPrefeitura: false,
			tudoSrf: false
		}
		this.abrirModal = this.abrirModal.bind(this);
		this.enviarInformativo = this.enviarInformativo.bind(this);
		this.fecharModal = this.fecharModal.bind(this);
		this.controlarArquivo = this.controlarArquivo.bind(this);
		this.controlarItem = this.controlarItem.bind(this);
		this.controlarItemCheckAf = this.controlarItemCheckAf.bind(this);
		this.controlarItemCheckPrefeitura = this.controlarItemCheckPrefeitura.bind(this);
		this.controlarItemCheckSrf = this.controlarItemCheckSrf.bind(this);
		this.controlarItemTudoAf = this.controlarItemTudoAf.bind(this);
		this.controlarItemTudoPrefeitura = this.controlarItemTudoPrefeitura.bind(this);
		this.controlarItemTudoSrf = this.controlarItemTudoSrf.bind(this);
		this.controlarItemTudoSrf = this.controlarItemTudoSrf.bind(this);
		this.controlarTabs = this.controlarTabs.bind(this);
	}

	componentDidMount() {

		let token_keycloack = sessionStorage.getItem('token_keycloack');
		const requestAuthorization = {
			headers: { "Authorization": `Bearer ${token_keycloack}` }
		}

		fetchWithToken(`${URL_API}/api/v1/parametro/obterParametro`, requestAuthorization)
			.then(_res => _res.json())
			.then(_res => {
				if (_res === "") {
					console.error("Arquivo não disponível")
				}
				else {
					this.setState({ assinatura: _res.find(o => o.campo === 'INFOASSINATURA')["valor"] })
					this.setState({ assunto: _res.find(o => o.campo === 'INFOASSUNTO')["valor"] })
					this.setState({ mensagem: _res.find(o => o.campo === 'INFOMENSAGEM')["valor"] })
					this.setState({ titulo: _res.find(o => o.campo === 'INFOTITULO')["valor"] })
				}
			})
			.catch(_err => {
				console.error("Ocorreu um erro - " + _err)
			})
		this.setState({ corpo: mensagem })
		fetchWithToken(`${URL_API}/api/v1/af/obterAf`, requestAuthorization)
			.then(res => res.json())
			.then(res => {
				if (res === "") {
					console.error("Arquivo não disponível")
				}
				else {
					this.setState({ dadosAf: res })
					let _itensAf = [];
					res.map(_item => {
						_itensAf[_item.codigo] = false
						return false
					})
					this.setState({ marcadosAf: _itensAf })
				}
			})
			.catch(_err => {
				console.error("Erro interno na aplicação.")
			});
		fetchWithToken(`${URL_API}/api/v1/prefeitura/obterPrefeitura`, requestAuthorization)
			.then(res => res.json())
			.then(res => {
				if (res === "") {
					console.error("Arquivo não disponível")
				}
				else {
					this.setState({ dadosPrefeitura: res })
					let _itensPrefeitura = [];
					res.map((_item) => (
						_itensPrefeitura[_item.codigo] = false
					))
					this.setState({ marcadosPrefeitura: _itensPrefeitura })
				}
			})
			.catch(_err => {
				console.error("Erro interno na aplicação.")
			});
		fetchWithToken(`${URL_API}/api/v1/srf/obterSrf`, requestAuthorization)
			.then(res => res.json())
			.then(res => {
				if (res === "") {
					console.error("Arquivo não disponível")
				}
				else {
					this.setState({ dadosSrf: res })
					let _itensSrf = [];
					res.map((_item) => (
						_itensSrf[_item.codigo] = false
					))
					this.setState({ marcadosSrf: _itensSrf })
					$(document).ready(function () {
						setTimeout(function () {
							$('#tblAf').DataTable({
								columnDefs: [
									{ orderable: false, targets: 0 }
								],
								lengthMenu: [[10, 50, 100, -1], [10, 50, 100, "Todos"]],
								pageLength: -1,
								language: {
									url: '/pt-BR.json'
								}
							});
							$('#tblPrefeitura').DataTable({
								columnDefs: [
									{ orderable: false, targets: 0 }
								],
								lengthMenu: [[10, 50, 100, -1], [10, 50, 100, "Todos"]],
								pageLength: -1,
								language: {
									url: '/pt-BR.json'
								}
							});
							$('#tblSrf').DataTable({
								columnDefs: [
									{ orderable: false, targets: 0 }
								],
								lengthMenu: [[10, 50, 100, -1], [10, 50, 100, "Todos"]],
								pageLength: -1,
								language: {
									url: '/pt-BR.json'
								}
							});
						}, 100);
					});
				}
			})
			.catch(_err => {
				alert("Erro interno na aplicação - " + _err)
				console.error("Erro interno na aplicação - " + _err)
			});
	}

	classifica(a, b) {
		if (a.nome > b.nome) { return 1; }
		if (a.nome < b.nome) { return -1; }
		return 0;
	}

	controlarArquivo(e) {
		this.definirVariaveis(e.target.files)
		const dados = new FormData()
		dados.append("file", e.target.files[0])
		let token_keycloack = sessionStorage.getItem('token_keycloack');
		const requestOptions = {
			method: 'POST',
			headers: { "Authorization": `Bearer ${token_keycloack}` },
			body: dados
		}
		fetchWithToken(`${URL_API}/api/v1/util/upload`, requestOptions)
			.then(res => {
				this.setState({ arquivoAnexado: true })
			})
			.catch((_err) => {
				console.error('Erro no upload do arquivo - ', _err)
			});
	}

	controlarItem = (e) => {
		this.setState({ [e.target.id]: e.target.value })
	}

	controlarItemCheckAf = (e) => {
		let id = e.target.id.substring(3)
		let _marcadosAf = this.state.marcadosAf
		let item = this.state.marcadosAf[id]
		_marcadosAf[id] = !item
		this.setState({ marcadosAf: _marcadosAf })
		if (!item) {
			this.setState({ idsAf: [...this.state.idsAf, id] })
		}
		else {
			const indice = this.state.idsAf.indexOf(id)
			let _idsAf = this.state.idsAf
			_idsAf.splice(indice, 1)
			this.setState({ idsAf: _idsAf })
		}
	}

	controlarItemCheckPrefeitura = (e) => {
		let id = e.target.id.substring(3)
		let marcadosPrefeitura = this.state.marcadosPrefeitura;
		let item = this.state.marcadosPrefeitura[id];
		marcadosPrefeitura[id] = !item;
		this.setState({ marcadosPrefeitura: marcadosPrefeitura });
		if (!item) {
			this.setState({ idsPrefeitura: [...this.state.idsPrefeitura, id] });
		}
		else {
			const indice = this.state.idsPrefeitura.indexOf(id)
			this.state.idsPrefeitura.splice(indice, 1)
			this.setState({ idsPrefeitura: this.state.idsPrefeitura })
		}
	}

	controlarItemCheckSrf = (e) => {
		let id = e.target.id.substring(3)
		let marcadosSrf = this.state.marcadosSrf;
		let item = this.state.marcadosSrf[id];
		marcadosSrf[id] = !item;
		this.setState({ marcadosSrf: marcadosSrf });
		if (!item) {
			this.setState({ idsSrf: [...this.state.idsSrf, id] });
		}
		else {
			const indice = this.state.idsSrf.indexOf(id)
			this.state.idsSrf.splice(indice, 1)
			this.setState({ ids: this.state.idsSrf })
		}
	}

	controlarItemTudoAf = (e) => {
		this.setState({ tudoAf: e.target.checked })
		
		Object.keys(this.state.marcadosAf).forEach((key) => {
            this.state.marcadosAf[key] = e.target.checked;
        });

		const idsAf = [];
		if (!this.state.tudoAf) {
			this.state.dadosAf.map((item) => (
				idsAf.push(item.codigo)
			))
		}
		this.setState({ idsAf: idsAf })
	}

	controlarItemTudoPrefeitura = (e) => {
		this.setState({ tudoPrefeitura: e.target.checked })
		
		Object.keys(this.state.marcadosPrefeitura).forEach((key) => {
            this.state.marcadosPrefeitura[key] = e.target.checked;
        });

		const idsPrefeitura = [];
		if (!this.state.tudoPrefeitura) {
			this.state.dadosPrefeitura.map((item) => (
				idsPrefeitura.push(item.codigo)
			))
		}
		this.setState({ idsPrefeitura: idsPrefeitura })
	}

	controlarItemTudoSrf = (e) => {
		this.setState({ tudoSrf: e.target.checked })
		
		Object.keys(this.state.marcadosSrf).forEach((key) => {
            this.state.marcadosSrf[key] = e.target.checked;
        });

		const idsSrf = [];
		if (!this.state.tudoSrf) {
			this.state.dadosSrf.map((item) => (
				idsSrf.push(item.codigo)
			))
		}
		this.setState({ idsSrf: idsSrf })
	}

	desmarcarSelecoesTodasAbas() {

		this.state.tudoAf = false;
		this.state.tudoPrefeitura = false;
		this.state.tudoSrf = false;

		Object.keys(this.state.marcadosSrf).forEach((key) => {
            this.state.marcadosSrf[key] = false;
        });

		Object.keys(this.state.marcadosPrefeitura).forEach((key) => {
            this.state.marcadosPrefeitura[key] = false;
        });

		Object.keys(this.state.marcadosAf).forEach((key) => {
            this.state.marcadosAf[key] = false;
        });
	}

	controlarTabs(_e, qual) {

		this.setState({ qualTab: qual })

		this.desmarcarSelecoesTodasAbas();
		setTimeout(function () {
			$('#tblAf').DataTable({
				columnDefs: [
					{ orderable: false, targets: 0 }
				],
				lengthMenu: [[10, 50, 100, -1], [10, 50, 100, "Todos"]],
				pageLength: -1,
				language: {
					url: '/pt-BR.json'
				}
			});
			$('#tblPrefeitura').DataTable({
				columnDefs: [
					{ orderable: false, targets: 0 }
				],
				lengthMenu: [[10, 50, 100, -1], [10, 50, 100, "Todos"]],
				pageLength: -1,
				language: {
					url: '/pt-BR.json'
				}
			});
			$('#tblSrf').DataTable({
				columnDefs: [
					{ orderable: false, targets: 0 }
				],
				lengthMenu: [[10, 50, 100, -1], [10, 50, 100, "Todos"]],
				pageLength: -1,
				language: {
					url: '/pt-BR.json'
				}
			});
		}, 100);
	}

	definirVariaveis(valor) {
		this.setState({ nomeArquivo: valor[0].name })
		this.setState({ arquivoAnexado: true })
	}

	enviarEmail(valor, tipo, id) {
		let hoje = new Date()
		const mes = ["janeiro", "fevereiro", "março", "abril", "maio", "junho", "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"][hoje.getMonth()];
		hoje = hoje.getDate() + " de " + mes + " de " + hoje.getFullYear()
		if(this.state.assunto === ""){
			alert("Informe o assunto do email")
			return false
		}		
		if(this.state.titulo === ""){
			alert("Informe o título do email")
			return false
		}
		if(this.state.mensagem === ""){
			alert("Informe o mensagem do email")
			return false
		}
		if (/\s|ç/.test(this.state.nomeArquivo)) {
			alert("O nome do arquivo não pode conter espaços ou o caractere 'ç'.");
			return false;
		}

		let token_keycloack = sessionStorage.getItem('token_keycloack');
		const requestOptions = {
			method: 'POST',
			headers: { 'Content-Type': 'application/x-www-form-urlencoded', "Authorization": `Bearer ${token_keycloack}` },
			body: "origem=vafsefmg@fazenda.mg.gov.br" +
				"&destinatario=" + valor.email +
				"&assunto=" + this.state.assunto +
				"&mensagem=" + encodeURIComponent(this.state.mensagem) +
				"&assinatura=" + this.state.assinatura +
				"&titulo=" + this.state.titulo +
				"&caminho_arquivo=" + this.state.nomeArquivo +
				"&nome_arquivo=" + this.state.nomeArquivo +
				"&codigo=" + valor.codigo +
				"&tipo_destino=" +tipo +
				"&tipoArquivo=EX"
		};
		fetchWithToken(`${URL_API}/api/v1/email/enviarInformativo`, requestOptions)
			.then(res => res.text())
			.then(res => {
				if (res === "OK") {
					this.setState({ mostraModal: true })
				}
			})
			.catch(_err => {
				alert("Erro interno na aplicação - " + _err)
				console.error("Erro interno na aplicação - " + _err)
			});
	}

	abrirModal() {
		this.setState({ mostraModal: true })
	}

	fecharModal() {
		this.setState({ mostraModal: false })
	}

	enviarInformativo() {
		if (this.state.idsAf.length + this.state.idsPrefeitura.length + this.state.idsSrf.length === 0) {
			alert("Nenhum destinatário selecionado!")
			return false
		}
		if (this.state.idsPrefeitura.length > 0) {
			this.setState({ qualTab: "2" })
			this.state.dadosPrefeitura.filter(item => { return this.state.idsPrefeitura.includes(item.codigo) }).map((valor) => {
				this.enviarEmail(valor, 'P', valor.codigo)
				return false
			})
		}
		if (this.state.idsAf.length > 0) {
			this.setState({ qualTab: "1" })
			this.state.dadosAf.filter(item => { return this.state.idsAf.includes(item.codigo) }).map((valor) => {
				this.enviarEmail(valor, 'A', valor.codigo)
				return false
			})
		}
		if (this.state.idsSrf.length > 0) {
			this.setState({ qualTab: "3" })
			this.state.dadosSrf.filter(item => { return this.state.idsSrf.includes(item.codigo) }).map((valor) => {
				this.enviarEmail(valor, 'S', valor.codigo)
				return false
			})
		}
	}

	render() {
		return (
			<div className="container-fluid">
				<div className="row">
					<div className="col-12">
						<header className="main">
							<h2>DISTVAF - Envio de Informativo</h2>
						</header>
					</div>
				</div>
				<div className="row">
					<div className="col-6">
					</div>
					<div className="col-6">
						<BotaoVoltar />
					</div>
				</div>
				<form>
					<div className="row">
						<div className="col-12">
							<Paper variant="outlined">
								<div className="cabecalho">
									Arquivo anexado
								</div>
								<label>Selecione o arquivo</label>
								<input type="file" name="arquivo" onChange={this.controlarArquivo} />
							</Paper>
						</div>
					</div>
					<div className="row">
						<div className="col-12">
							<Paper variant="outlined">
								<div className="cabecalho">
									Dados do e-mail
								</div>
								<label htmlFor="txtAssunto" className="margem-antes" maxLength="100">Assunto</label>
								<input type="text" name="assunto" id="assunto" value={this.state.assunto} onChange={this.controlarItem} />
								<label htmlFor="txtTitulo" className="margem-antes">Título</label>
								<input type="text" name="titulo" id="titulo" value={this.state.titulo} onChange={this.controlarItem} />
								<label htmlFor="txtMensagem" className="margem-antes">Mensagem</label>
								<textarea name="mensagem" id="mensagem" value={this.state.mensagem} onChange={this.controlarItem} rows="5" />
								<label htmlFor="txtAssinatura" className="margem-antes">Assinatura</label>
								<textarea name="assinatura" id="assinatura" value={this.state.assinatura} onChange={this.controlarItem} rows="3" html />
							</Paper>
						</div>
					</div>
					<div className="row">
					<div className="row">
						<div className="col-12">
							<label className="margem-antes"></label>
							<Button variant="contained" color="primary" onClick={() => this.enviarInformativo()}>Enviar informativo</Button>
							<br></br><br></br>
						</div>
					</div>
						<div className="col-12">
							<Paper variant="outlined">
								<div className="cabecalho">
									Seleção dos destinatários
								</div>
								<TabContext value={this.state.qualTab}>
									<TabList onChange={this.controlarTabs}>
										<Tab label="Prefeitura" value="2" id="tabPrefeitura"/>
										<Tab label="AF" value="1"  />										
										<Tab label="SRF" value="3" />
									</TabList>
									<TabPanel value="1">
										<div className="table-wrapper ">
											<table id="tblAf" className="stripe row-border">
												<thead>
													<tr>
														<th className='caixa'><input type="checkbox" id="chkTudoAf" checked={this.state.tudoAf} onChange={this.controlarItemTudoAf} /><label htmlFor="chkTudoAf"> </label></th>
														<th>AF</th>
													</tr>
												</thead>
												<tbody>
													{this.state.dadosAf.sort(this.classifica).map((reg) => {
														return (
															<tr key={"af_" + reg.codigo}>
																<td className='caixa'><input type="checkbox" id={"af_" + reg.codigo} checked={this.state.marcadosAf[reg.codigo] || false} onChange={this.controlarItemCheckAf} value={reg.email} /><label htmlFor={"af_" + reg.codigo}></label></td>
																<td>{reg.nome}</td>
															</tr>
														)
													})}
												</tbody>
											</table>
										</div>
									</TabPanel>
									<TabPanel value="2">
										<div className="table-wrapper ">
											<table id="tblPrefeitura" className="stripe row-border">
												<thead>
													<tr>
														<th className='caixa'><input type="checkbox" id="chkTudoPrefeitura" checked={this.state.tudoPrefeitura} onChange={this.controlarItemTudoPrefeitura} /><label htmlFor="chkTudoPrefeitura"> </label></th>
														<th>Município</th>
													</tr>
												</thead>
												<tbody>
													{this.state.dadosPrefeitura.sort(this.classifica).map((reg) => {
														return (
															<tr key={"pr_" + reg.codigo}>
																<td className='caixa'><input type="checkbox" id={"pr_" + reg.codigo} checked={this.state.marcadosPrefeitura[reg.codigo] || false} onChange={this.controlarItemCheckPrefeitura} value={reg.email} /><label htmlFor={"pr_" + reg.codigo}></label></td>
																<td>{reg.nome}</td>
															</tr>
														)
													})}
												</tbody>
											</table>
										</div>
									</TabPanel>
									<TabPanel value="3">
										<div className="table-wrapper ">
											<table id="tblSrf" className="stripe row-border">
												<thead>
													<tr>
														<th className='caixa'><input type="checkbox" id="chkTudoSrf" checked={this.state.tudoSrf} onChange={this.controlarItemTudoSrf} /><label htmlFor="chkTudoSrf"> </label></th>
														<th>SRF</th>
													</tr>
												</thead>
												<tbody>
													{this.state.dadosSrf.sort(this.classifica).map((reg) => {
														return (
															<tr key={"sr_" + reg.codigo}>
																<td className='caixa'><input type="checkbox" id={"sr_" + reg.codigo} checked={this.state.marcadosSrf[reg.codigo] || false} onChange={this.controlarItemCheckSrf} value={reg.email} /><label htmlFor={"sr_" + reg.codigo}></label></td>
																<td>{reg.nome}</td>
															</tr>
														)
													})}
												</tbody>
											</table>
										</div>
									</TabPanel>
								</TabContext>
							</Paper>
						</div>
					</div>
					<div className="col-12">
						<BotaoVoltar />
					</div>
					
				</form>
				<Dialog open={this.state.mostraModal} aria-labelledby="customized-dialog-title">
					<DialogTitle id="customized-dialog-title">
						Processamento concluído
					</DialogTitle>
					<DialogContent dividers>
						<table id="tblEnviados">
							Informativo enviado!
						</table>
					</DialogContent>
					<DialogActions>
						<Button  variant="contained" color="primary"  onClick={this.fecharModal}>
							Fechar
						</Button>
					</DialogActions>
				</Dialog>
			</div >
		)
	}
}

export default EnviarInformativo